module.exports = __webpack_public_path__ + "img/annotation-check.a4dcabab.svg";